export const getAdvanceRequests = 'Merchant/GetAdvanceRequests';
